interface DashboardMiniDisplayProps {
  topLeftText: string;
  topRightText: string;
  mainText: string;
  subText: string;
  progressPercentage?: number;
}

const DashboardMiniDisplay = ({
  topLeftText,
  topRightText,
  mainText,
  subText,
  progressPercentage = 0,
}: DashboardMiniDisplayProps) => {
  const styles = {
    container: {
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
      padding: "20px",
      backgroundColor: "#f9f9f9",
      height: "200px",
      minWidth: "250px",
      boxSizing: "border-box",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
    } as React.CSSProperties,
    topRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "16px",
    } as React.CSSProperties,
    topLeftText: {
      fontSize: "12px",
      fontWeight: "600",
      color: "#999",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      margin: "0",
    } as React.CSSProperties,
    topRightText: {
      fontSize: "12px",
      fontWeight: "600",
      color: "#4caf50",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      margin: "0",
    } as React.CSSProperties,
    mainNumber: {
      fontSize: "32px",
      fontWeight: "bold",
      color: "#000",
      margin: "0 0 8px 0",
    } as React.CSSProperties,
    subText: {
      fontSize: "13px",
      color: "#999",
      margin: "0 0 16px 0",
    } as React.CSSProperties,
    progressBar: {
      width: "100%",
      height: "8px",
      backgroundColor: "#e0e0e0",
      borderRadius: "4px",
      overflow: "hidden",
    } as React.CSSProperties,
    progressFill: {
      height: "100%",
      width: `${progressPercentage}%`,
      backgroundColor: "blue",
      borderRadius: "4px",
      transition: "width 0.3s ease",
    } as React.CSSProperties,
  };

  return (
    <div style={styles.container}>
      <div style={styles.topRow}>
        <p style={styles.topLeftText}>{topLeftText}</p>
        <p style={styles.topRightText}>{topRightText}</p>
      </div>
      <p style={styles.mainNumber}>{mainText}</p>
      <p style={styles.subText}>{subText}</p>
      <div style={styles.progressBar}>
        <div style={styles.progressFill}></div>
      </div>
    </div>
  );
};

export default DashboardMiniDisplay;
